export default __webpack_public_path__ + "static/media/dizzy.01a8c747.jpg";